import { render, staticRenderFns } from "./InsuranceQuotes.vue?vue&type=template&id=15a3aaa6"
import script from "./InsuranceQuotes.vue?vue&type=script&lang=js"
export * from "./InsuranceQuotes.vue?vue&type=script&lang=js"
import style0 from "./InsuranceQuotes.vue?vue&type=style&index=0&id=15a3aaa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports